import { Observable } from "rxjs/Observable";
import { map } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { Http, Headers } from "@angular/http";
import { environment } from "../../environments/environment";

interface IServerResponse {
  result: Observable<any>;
  count: number;
  check: number;
}

const API_URL = environment.API_URL + "/user";
const ADMIN_API_URL = environment.API_URL + "/admin";

@Injectable()
export class UserService {
  constructor(private http: HttpClient, private https: Http) {}

  /* total no of users */
  getusertotal() {
    return this.https.get(API_URL + "/usercount/").pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  /* get user info */

  getuserinfo(id) {
    return this.https.get(API_URL + "/userinfo/" + id).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  /* get channel admin info */

  getchanneladmininfo(id) {
    return this.https.get(API_URL + "/getchanneladmininfo/" + id).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  /* get channel info */

  getuserchannelinfo(id) {
    return this.https.get(API_URL + "/userchannelinfo/" + id).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  /* get channel report info */

  getuserchannelreportinfo(id) {
    return this.https.get(API_URL + "/userchannelreportinfo/" + id).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  /* get user list */
  getuserlist() {
    return this.https.get(API_URL + "/getallusers/").pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  /* get user list observer*/
  getuserlistobserve(page: number): Observable<IServerResponse> {
    return this.https.get(API_URL + "/getallusersobserve/" + page).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  /* get all user list observer*/
  getuserlistobservefilterpage(
    page: number,
    filterValue: string
  ): Observable<IServerResponse> {
    return this.https
      .get(
        API_URL + "/getuserlistobservefilterpage/" + page + "/" + filterValue
      )
      .pipe(
        map((res) => {
          //console.log(filterValue);
          // console.log(res);
          return res.json();
        })
      );
  }

  /* get all user list filter observer*/
  getuserlistobservefilter(filterValue: string): Observable<IServerResponse> {
    return this.https
      .get(API_URL + "/getuserlistobservefilter/" + filterValue)
      .pipe(
        map((res) => {
          return res.json();
        })
      );
  }

  /* get own channels list */

  getownchannelsinfo(id) {
    return this.https.get(API_URL + "/ownchannelsinfo/" + id).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  /* get reported channels list */

  getreportedchannelsinfo(id) {
    return this.https.get(API_URL + "/reportedchannelsinfo/" + id).pipe(
      map((res) => {
        return res.json();
      })
    );
  }
  /* get subscribed channels list */

  getsubscribedchannelsinfo(id) {
    return this.https.get(API_URL + "/subscribedchannelsinfo/" + id).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  /* get user group list */

  getusergroup(id) {
    return this.https.get(API_URL + "/usergroupinfo/" + id).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  /* get user contacts list */

  getusercontacts(id) {
    return this.https.get(API_URL + "/getusercontacts/" + id).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  /* get user recent calls list */

  getuserrecentcalls(id) {
    return this.https.get(API_URL + "/userrecentcallsinfo/" + id).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  /* get active user channels list */
  getuserchannelslist() {
    return this.https.get(API_URL + "/getuserchannels/").pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  /* get active channel list filter observer*/
  getactivechannellistobservefilter(
    filterValue: string
  ): Observable<IServerResponse> {
    return this.https
      .get(API_URL + "/getactivechannellistobservefilter/" + filterValue)
      .pipe(
        map((res) => {
          return res.json();
        })
      );
  }

  /* get active channel list observer*/
  getactivechannellistobserve(page: number): Observable<IServerResponse> {
    return this.https
      .get(API_URL + "/getactivechannellistobserve/" + page)
      .pipe(
        map((res) => {
          return res.json();
        })
      );
  }

  /* Promote user to merchant (Admin) */
  promoteToMerchant(user_id: string) {
    return this.https
      .post(ADMIN_API_URL + "/merchant/promote", { user_id })
      .pipe(map((res) => res.json()));
  }

  /* Depromote merchant to normal user (Admin) */
  depromoteMerchant(user_id: string) {
    return this.https
      .post(ADMIN_API_URL + "/merchant/depromote", { user_id })
      .pipe(map((res) => res.json()));
  }

  /* Promote normal user to shareholder (Admin) */
  promoteShareholder(user_id: string, share_percent: number) {
    return this.https
      .post(ADMIN_API_URL + "/shareholder/promote", { user_id, share_percent })
      .pipe(map((res) => res.json()));
  }

  /* Depromote shareholder to normal user (Admin) */
  depromoteShareholder(user_id: string) {
    return this.https
      .post(ADMIN_API_URL + "/shareholder/depromote", { user_id })
      .pipe(map((res) => res.json()));
  }

  /* Promote normal user to G Fire admin / super_admin / master_admin */
  promoteGfireAdmin(user_id: string, gfire_admin_role: string) {
    return this.https
      .post(ADMIN_API_URL + "/gfire/admin/promote", { user_id, gfire_admin_role })
      .pipe(map((res) => res.json()));
  }

  /* Remove G Fire admin role from user */
  depromoteGfireAdmin(user_id: string) {
    return this.https
      .post(ADMIN_API_URL + "/gfire/admin/depromote", { user_id })
      .pipe(map((res) => res.json()));
  }

  /* Reset user wallet password (Admin) */
  resetUserWalletPassword(user_id: string) {
    return this.https
      .put(ADMIN_API_URL + "/resetuserwalletpassword/" + user_id, {})
      .pipe(map((res) => res.json()));
  }

  /* Lock or unlock user wallet (Admin) */
  lockOrUnlockUserWallet(user_id: string, lock: boolean, reason: string) {
    return this.https
      .put(ADMIN_API_URL + "/lockorunlockuserwallet/" + user_id, { lock, reason })
      .pipe(map((res) => res.json()));
  }

  /* Get shareholder stats (Admin) */
  getShareholderStats() {
    return this.https
      .get(ADMIN_API_URL + "/shareholder/stats")
      .pipe(map((res) => res.json()));
  }

  /* Get shareholders list (Admin) */
  getShareholders(page: number = 1, limit: number = 15, search: string = "") {
    const encodedSearch = encodeURIComponent(search || "");
    return this.https
      .get(
        ADMIN_API_URL +
          "/shareholder/list?page=" +
          page +
          "&limit=" +
          limit +
          "&search=" +
          encodedSearch
      )
      .pipe(map((res) => res.json()));
  }

  /* Update shareholder percentage (Admin) */
  updateShareholderPercent(user_id: string, share_percent: number) {
    return this.https
      .post(ADMIN_API_URL + "/shareholder/update-percent", {
        user_id,
        share_percent,
      })
      .pipe(map((res) => res.json()));
  }

  /* get adminchannel list observer*/
  getactivechannellistobservefilterpage(
    page: number,
    filterValue: string
  ): Observable<IServerResponse> {
    return this.https
      .get(
        API_URL +
          "/getactivechannellistobservefilterpage/" +
          page +
          "/" +
          filterValue
      )
      .pipe(
        map((res) => {
          return res.json();
        })
      );
  }

  /* get blocked channel list filter observer*/
  getblockedchannellistobservefilter(
    filterValue: string
  ): Observable<IServerResponse> {
    return this.https
      .get(API_URL + "/getblockedchannellistobservefilter/" + filterValue)
      .pipe(
        map((res) => {
          return res.json();
        })
      );
  }

  /* get active channel list observer*/
  getblockedchannellistobserve(page: number): Observable<IServerResponse> {
    return this.https
      .get(API_URL + "/getblockedchannellistobserve/" + page)
      .pipe(
        map((res) => {
          return res.json();
        })
      );
  }

  /* get adminchannel list observer*/
  getblockedchannellistobservefilterpage(
    page: number,
    filterValue: string
  ): Observable<IServerResponse> {
    return this.https
      .get(
        API_URL +
          "/getblockedchannellistobservefilterpage/" +
          page +
          "/" +
          filterValue
      )
      .pipe(
        map((res) => {
          //console.log(filterValue);
          // console.log(res);
          return res.json();
        })
      );
  }

  /* block channels */
  blockchannel(id) {
    return this.https.delete(API_URL + "/blockchannel/" + id).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  /* get blocked user channels list */
  getblockedchannelslist() {
    return this.https.get(API_URL + "/getblockedchannels/").pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  /* get groups list */
  getgrouplist() {
    return this.https.get(API_URL + "/getallgroups/").pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  /* get recent users list */
  getusercountrylist() {
    return this.https.get(API_URL + "/getuserscountry/").pipe(
      map((res) => {
        return res.json();
      })
    );
  }
  /* get users' country */
  getrecentuserlist() {
    return this.https.get(API_URL + "/getrecentusers/").pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  /* get recent groups list */
  getrecentgrouplist() {
    return this.https.get(API_URL + "/getrecentgroups/").pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  /* get platform users list */
  getplatformusers() {
    return this.https.get(API_URL + "/getplatformlist/").pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  /* get public channels list */
  getpublicchannelslist() {
    return this.https.get(API_URL + "/getpublicchannels/").pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  /* get online users list */
  getonlineusers() {
    return this.https.get(API_URL + "/getonlineusers/").pipe(
      map((res) => {
        return res.json();
      })
    );
  }
  /* get online users list */
  getstatuscount() {
    return this.https.get(API_URL + "/getstatuscount/").pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  /* get all channels list */
  gettotalchannelslist() {
    return this.https.get(API_URL + "/gettotalchannels/").pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  /* get platform users list */
  getprivatechannelslist() {
    return this.https.get(API_URL + "/getprivatechannels/").pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  /* get by this month */
  getcountbythismonth() {
    return this.https.get(API_URL + "/getmonthlist/").pipe(
      map((res) => {
        return res.json();
      })
    );
  }
  /* get by today */
  getcountbytoday() {
    return this.https.get(API_URL + "/gettodaylist/").pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  /* get by this year */
  getcountbythisyear() {
    return this.https.get(API_URL + "/getyearlist/").pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  /* get reports */
  getviewreports(id) {
    return this.https.get(API_URL + "/channelreports/" + id).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  /* get by today */
  getsharedmediacount() {
    return this.https.get(API_URL + "/getsharedmedia/").pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  /* get recent days status count */
  getstatusmediacount() {
    return this.https.get(API_URL + "/getstatusmedia/").pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  /* manage channel */
  channelmanagement(id) {
    return this.https.delete(API_URL + "/blockit/" + id).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  /* manage report */
  reportmanagement(id) {
    return this.https.delete(API_URL + "/deletereport/" + id).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  getallwalltetransaction(formdata,page,status) {
    const Url = API_URL + "/wallettransaction/"+`${status}/`+page+`?type=${formdata.type}&start_date=${formdata.start_date}&end_date=${formdata.end_date}`;
    return this.https.get(Url).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  getFullwalltetransaction(formdata,status) {
    const Url = API_URL + "/getFullWalletHistory/"+`${status}/`+`?type=${formdata.type}&start_date=${formdata.start_date}&end_date=${formdata.end_date}`;
    return this.https.get(Url).pipe(
      map((res) => {
        return res.json();
      })
    );
  }


  promotetosuperadmin(formdata) {
    const Url = API_URL + "/change_user_type";
    return this.https.post(Url, formdata).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  demoteuser(formdata) {
    const Url = API_URL + "/demoteagent";
    return this.https.post(Url, formdata).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  getagents(formdata) {
    const Url = API_URL + "/getagents";
    return this.https.post(Url, formdata).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  getcommissionlist(formdata) {
    const Url = API_URL + "/commissionlist";
    return this.https.post(Url, formdata).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  createcommission(formdata) {
    const Url = API_URL + "/createcommission";
    return this.https.post(Url, formdata).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  getcommissions(formdata) {
    const Url = API_URL + "/getcommissions";
    return this.https.post(Url, formdata).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  updateCommissions(formdata) {
    const Url = API_URL + "/update_commissions";
    return this.https.post(Url, formdata).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  deletecommission(formdata) {
    const Url = API_URL + "/deletecommission";
    return this.https.post(Url, formdata).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  gettransfercommission() {
    const Url = API_URL + "/gettransfercommission";
    return this.https.post(Url, {}).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  createtransfercommission(formdata) {
    const Url = API_URL + "/createtransfercommission";
    return this.https.post(Url, formdata).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  gettransfercommissionbyid(formdata) {
    const Url = API_URL + "/gettransfercommissionbyid";
    return this.https.post(Url, formdata).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  edittransfercommission(formdata) {
    const Url = API_URL + "/edittransfercommission";
    return this.https.post(Url, formdata).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  deletetransfercommission(formdata) {
    const Url = API_URL + "/deletetransfercommission";
    return this.https.post(Url, formdata).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  getUserTransaction(page: any, id: any, data: any) {
    let type = "";
    let start_date = "";
    let end_date = "";

    if (data.type == "all") {
      type = "";
    } else {
      type = data.type;
    }

    if (data.start_date != null) {
      start_date = data.start_date;
    }

    if (data.end_date != null) {
      end_date = data.end_date;
    }

    let url =
      API_URL +
      `/getUserTransactions/${id}/${page}?type=${type}&start_date=${start_date}&end_date=${end_date}`;

    return this.https.get(url).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  getagentlist(id:any,page:number,search:string){
    let url = API_URL + "/getagentlist/"+id+"/"+page+"?search="+search
    return this.https.get(url).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  denyTransaction(formdata){
    let url = API_URL + "/denyTransaction"
    return this.https.post(url,formdata).pipe(
      map((res)=>{
        return res.json()
      })
    )
  }

  bancobuTransactions(page: any, data: any){
    let type = "";
    let start_date = "";
    let end_date = "";

    if (data.type == "all") {
      type = "";
    } else {
      type = data.type;
    }

    if (data.start_date != null) {
      start_date = data.start_date;
    }

    if (data.end_date != null) {
      end_date = data.end_date;
    }

    let url =
      API_URL +
      `/bancobu_transaction/${page}?type=${type}&start_date=${start_date}&end_date=${end_date}`;

    return this.https.get(url).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  approveTransaction(formdata){
    let url = API_URL + "/approveWithdrawels"
    return this.https.post(url,formdata).pipe(
      map((res)=>{
        return res.json()
      })
    )
  }

  getTotalWallet(page: any, data: any){
    let search = "";
    let start_date = "";
    let end_date = "";

    if (data.search == "") {
      search = "";
    } else {
      search = data.search;
    }

    if (data.start_date != null) {
      start_date = data.start_date;
    }

    if (data.end_date != null) {
      end_date = data.end_date;
    }

    let url =
      API_URL +
      `/getTotalWallet/${page}?search=${search}&start_date=${start_date}&end_date=${end_date}&wallet_start_date=${data.wallet_start_date}&wallet_end_date=${data.wallet_end_date}`;

    return this.https.get(url).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  getInwallet(page: any, id: any, data: any) {
    let type = "";
    let start_date = "";
    let end_date = "";

    if (data.type == "") {
      type = "";
    } else {
      type = data.type;
    }

    if (data.start_date != null) {
      start_date = data.start_date;
    }

    if (data.end_date != null) {
      end_date = data.end_date;
    }

    let url =
      API_URL +
      `/getInwalletTransactions/${id}/${page}?type=${type}&start_date=${start_date}&end_date=${end_date}`;

    return this.https.get(url).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  //FULL STARTS
  getFullUserTransaction( id: any, data: any) {
    let type = "";
    let start_date = "";
    let end_date = "";

    if (data.type == "all") {
      type = "";
    } else {
      type = data.type;
    }

    if (data.start_date != null) {
      start_date = data.start_date;
    }

    if (data.end_date != null) {
      end_date = data.end_date;
    }

    let url =
      API_URL +
      `/getfullUserTransactions/${id}?type=${type}&start_date=${start_date}&end_date=${end_date}`;

    return this.https.get(url).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  fullbancobuTransactions(data: any){
    let type = "";
    let start_date = "";
    let end_date = "";

    if (data.type == "all") {
      type = "";
    } else {
      type = data.type;
    }

    if (data.start_date != null) {
      start_date = data.start_date;
    }

    if (data.end_date != null) {
      end_date = data.end_date;
    }

    let url =
      API_URL +
      `/getfullbancobutransaction?type=${type}&start_date=${start_date}&end_date=${end_date}`;

    return this.https.get(url).pipe(
      map((res) => {
        return res.json();
      })
    );
  }


  getFullTotalWallet( data: any){
    let search = "";
    let start_date = "";
    let end_date = "";

    if (data.search == "") {
      search = "";
    } else {
      search = data.search;
    }

    if (data.start_date != null) {
      start_date = data.start_date;
    }

    if (data.end_date != null) {
      end_date = data.end_date;
    }

    let url =
      API_URL +
      `/getFullTotalWallet?search=${search}&start_date=${start_date}&end_date=${end_date}`;

    return this.https.get(url).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  getFullInwallet( id: any, data: any) {
    let type = "";
    let start_date = "";
    let end_date = "";

    if (data.type == "") {
      type = "";
    } else {
      type = data.type;
    }

    if (data.start_date != null) {
      start_date = data.start_date;
    }

    if (data.end_date != null) {
      end_date = data.end_date;
    }

    let url =
      API_URL +
      `/getFullInwallet/${id}?type=${type}&start_date=${start_date}&end_date=${end_date}`;

    return this.https.get(url).pipe(
      map((res) => {
        return res.json();
      })
    );
  }

  /* Get shareholder commission history (Admin) */
  getShareholderCommissionHistory(
    page: number = 1,
    limit: number = 15,
    search: string = "",
    start_date: string = "",
    end_date: string = ""
  ) {
    const encodedSearch = encodeURIComponent(search || "");
    return this.https
      .get(
        ADMIN_API_URL +
          "/shareholder/commission-history?page=" +
          page +
          "&limit=" +
          limit +
          "&search=" +
          encodedSearch +
          "&start_date=" +
          start_date +
          "&end_date=" +
          end_date
      )
      .pipe(map((res) => res.json()));
  }

  /* Get shareholder overview (Admin) */
  getShareholderOverview() {
    return this.https
      .get(ADMIN_API_URL + "/shareholder/overview")
      .pipe(map((res) => res.json()));
  }
}
